//PROEFEX - Archivo ceado por PROEFEX para uso de teléfono en registro - INICIO
document.addEventListener('DOMContentLoaded', function() {
  const phoneInputField = document.querySelector("#phone");

  if (phoneInputField) {
    const intlTelInputInstance = window.intlTelInput(phoneInputField, {
      initialCountry: "auto",
      geoIpLookup: function(callback) {
        fetch('https://ipinfo.io/json')
          .then(response => response.json())
          .then(data => callback(data.country))
          .catch(() => callback('us')); 
      },
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.0.7/build/js/utils.js"
    });

    const form = phoneInputField.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        if (!intlTelInputInstance.isValidNumber()) {
          alert('Por favor, introduce un número de teléfono válido.');
          e.preventDefault(); 
        } else {
          // Obtiene el número completo en formato internacional (por ejemplo, +525512345678)
          const fullNumber = intlTelInputInstance.getNumber();

          // **Este es el paso crucial:** Asigna el número completo al campo de entrada.
          phoneInputField.value = fullNumber;
        }
      });
    }
  }
});
//PROEFEX - Archivo ceado por PROEFEX para uso de teléfono en registro - FIN
